<template>
  <div
    class="m-8 mx-auto organism text-cta p-9 grid grid-cols-12 gap-4 outline outline-1 outline-gray-400 max-w-7xl"
    :class="organism.removeMargin"
  >
    <h2
      class="flex items-center justify-center text-4xl text-center col-span-full lg:col-span-3 theme-text-2xl"
    >
      {{ organism.title1 }}
    </h2>
    <div
      class="col-span-full lg:col-span-6"
      v-html="organism.description"
    ></div>
    <MoleculesButtons
      class="flex items-center !justify-center col-span-full lg:col-span-3"
      :buttons="organism"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  organism: Object,
});
</script>
